import React, { FC, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.div<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 770px;
  background-color: #fff;

  ${props =>
    props.$isMobile
      ? css``
      : css`
          border-left: 1px solid #eaebec;
          border-right: 1px solid #eaebec;
        `}
`;

interface Props extends PropsWithChildren {
  isMobile: boolean;
}

const WrapperContainer: FC<Props> = props => {
  const { isMobile, children } = props;
  return <Wrapper $isMobile={isMobile}>{children}</Wrapper>;
};

export default WrapperContainer;
